import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnProtectionGeneralConfigurationSkeleton = () => {
  return (
    <Styles.Container data-testid="return-protection-general-skeleton">
      <Skeleton variant="text" width={160} height={28} />
      <Skeleton variant="text" width="100%" height={20} />
      <Styles.Tags>
        <Skeleton variant="rounded" width={96} height={24} />
        <Skeleton variant="rounded" width={96} height={24} />
        <Skeleton variant="rounded" width={96} height={24} />
      </Styles.Tags>
    </Styles.Container>
  )
}

export default ReturnProtectionGeneralConfigurationSkeleton
